"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translation_pl = void 0;
exports.translation_pl = {
    activationQR: {
        title: 'Kod konfiguracyjny bramy',
        gateName: 'Nazwa bramy',
        controller: 'Kontroler'
    },
    ticket: {
        organizer: 'Organizator',
        ticketLabel: 'Bilet wstępu na wydarzenie',
        moreInfo: 'więcej informacji',
        demo: 'WERSJA DEMO'
    }
};
